import React from 'react';
import firebase from '../../firebase';
import { connect } from 'react-redux';
import { setCurrentChannel, setPrivateChannel, setExplorePage } from '../../actions';
import dmIcon from '../Images/dmIcon.png';
import { Menu, Icon } from 'semantic-ui-react';


class DirectMessages extends React.Component {
    state = {
        activeChannel: '',
        user: this.props.currentUser,
        users: [],
        usersRef: firebase.database().ref('allUsers'),
        connectedRef: firebase.database().ref('.info/connected'),
        presenceRef: firebase.database().ref('presence')
    }

    componentDidMount() {
        if (this.state.user) {
            this.addListeners(this.state.user.uid);
        }
    }

    componentWillUnmount() {
        this.removeListeners();
    }

    removeListeners = () => {
        this.state.usersRef.off();
        this.state.presenceRef.off();
        this.state.connectedRef.off();
    }

    addListeners = currentUserUid => {
        let loadedUsers = [];
        this.state.usersRef.on('child_added', snap => {
            if (currentUserUid !== snap.key) {
                let user = snap.val();
                user['uid'] = snap.key;
                user['status'] = 'offline';
                loadedUsers.push(user);
                this.setState({ users: loadedUsers });
            }
        });

        this.state.connectedRef.on('value', snap => {
            if (snap.val() === true) {
                const ref = this.state.presenceRef.child(currentUserUid);
                ref.set(true);
                ref.onDisconnect().remove(err => {
                    if (err !== null) {
                        console.error(err);
                    }
                })
            }
        });

        this.state.presenceRef.on('child_added', snap => {
            if (currentUserUid !== snap.key) {
                this.addStatusToUser(snap.key);
            }
        });

        this.state.presenceRef.on('child_removed', snap => {
            if (currentUserUid !== snap.key) {
                this.addStatusToUser(snap.key, false);
            }
        });
    }

    addStatusToUser = (userId, connected = true) => {
        const updatedUsers = this.state.users.reduce((acc, user) => {
            if (user.uid === userId) {
                user['status'] = `${connected ? 'online' : 'offline'}`;
            }
            return acc.concat(user);
        }, []);
        this.setState({ users: updatedUsers });
    }

    isUserOnline = user => user.status === 'online';

    changeChannel = user => {
        const channelId = this.getChannelId(user.uid);
        const channelData = {
            id: channelId,
            name: user.name
        };
        this.props.setCurrentChannel(channelData);
        this.props.setPrivateChannel(true);
        this.props.setExplorePage(false);
        this.setActiveChannel(user.uid);
    };

    getChannelId = userId => {
        const currentUserId = this.state.user.uid;
        return userId < currentUserId ? 
        `${userId}/${currentUserId}` : `${currentUserId}/${userId}`;
    };

    setActiveChannel = userId => {
        this.setState({ activeChannel: userId });
    }

    render() {
        const { users, activeChannel } = this.state;

        return (
            <React.Fragment>
                <Menu.Menu>
                    <Menu.Item className="channelMenuItem" style={{color: '#fff', paddingBottom: '16px', marginLeft: '-10px'}}>
                        <span className="channelSpan" 
                            style={{ 
                            fontFamily: 'proxima-nova, sans-serif',
                            fontWeight: 500,
                            fontStyle: 'normal',
                            color: '#fff' }}>
                            <img src={dmIcon} alt="Icon" className="channelIcon" />&nbsp;&nbsp;DIRECT MESSAGES ({ users.length })
                        </span>
                    </Menu.Item>
                    <div className="dmText">
                        {users.map(user => (
                            <Menu.Item
                                key={user.uid}
                                active={user.uid === activeChannel}
                                onClick={() => this.changeChannel(user)}
                            >
                            <Icon
                                name="circle"
                                color={this.isUserOnline(user) ? 'green' : 'red'}
                                style= {{
                                    marginTop: '5px',
                                }}
                            />

                            <div
                            style={{ display: 'flex', alignItems: 'center',
                                    fontFamily: 'proxima-nova, sans-serif',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    fontSize: '14px',
                                    marginTop: '3.75px',
                                    color: '#fff'
                                    }}>
                            <div 
                            className="channelCircleShape"
                            style={{
                                width: '9px',
                                height: '9px',
                                marginTop: '-5px'
                            }}>@</div>&nbsp;&nbsp;&nbsp;{user.name}
                            </div>
                            </Menu.Item>
                        ))}
                    </div>
                </Menu.Menu>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.currentUser
});

export default connect(mapStateToProps, { setCurrentChannel, setPrivateChannel, setExplorePage })(DirectMessages);


// WEBPACK FOOTER //
// ./src/components/SidePanel/DirectMessages.js